import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

Vue.use(Router)

// 修复重复导航/重定向报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'hash',
  base: '/',
  routes: [
    { 
      path: '/redirect/:path*', 
      component: () => import('@/views/Redirect.vue'), 
      hidden: true 
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login.vue'),
      meta: { public: true }
    },
    {
      path: '/',
      component: () => import('@/components/Layout.vue'),
      redirect: '/survey',
      children: [
        // 店铺概况
        { path: 'survey', name: 'Survey', component: () => import('@/views/Survey.vue'), meta: { title: '店铺概况' } },
        { path: 'shop-overview', name: 'ShopOverview', component: () => import('@/views/ShopOverview.vue'), meta: { title: '店铺概况' } },
        // 店面业务
        { path: 'business/cashier', name: 'Cashier', component: () => import('@/views/Business/Cashier.vue'), meta: { title: '收银台' } },
        { path: 'business/order', name: 'Order', component: () => import('@/views/Business/Order.vue'), meta: { title: '订单管理' } },
        { path: 'business/settle', name: 'Settle', component: () => import('@/views/Business/Settle.vue'), meta: { title: '结账' } },
        { path: 'business/reservation', name: 'Reservation', component: () => import('@/views/Business/Reservation.vue'), meta: { title: '预约服务' } },
        { path: 'business/wash-report', name: 'WashReport', component: () => import('@/views/Business/WashReport.vue'), meta: { title: '洗护报告' } },
        { path: 'business/grooming-template-list', name: 'GroomingTemplateList', component: () => import('@/views/Business/GroomingTemplateList.vue'), meta: { title: '检查项目模板' } },
        { path: 'business/grooming-template-edit', name: 'GroomingTemplateEdit', component: () => import('@/views/Business/GroomingTemplateEdit.vue'), meta: { title: '编辑检查项目模板' } },
        { path: 'business/boarding', name: 'Boarding', component: () => import('@/views/Business/Boarding.vue'), meta: { title: '寄养管理' } },
        { path: 'business/remind', name: 'Remind', component: () => import('@/views/Business/Remind.vue'), meta: { title: '提醒中心' } },
        { path: 'business/account-book', name: 'AccountBook', component: () => import('@/views/Business/AccountBook.vue'), meta: { title: '记账本' } },
        { path: 'business/account-book-project', name: 'AccountBookProject', component: () => import('@/views/Business/AccountBookProject.vue'), meta: { title: '项目管理' } },
        // 客户中心
        { path: 'customer/list', name: 'CustomerList', component: () => import('@/views/Customer/CustomerList.vue'), meta: { title: '客户管理' } },
        { path: 'customer/detail/:id', name: 'CustomerDetail', component: () => import('@/views/Customer/CustomerDetail.vue'), meta: { title: '会员详情' } },
        { path: 'customer/pet', name: 'Pet', component: () => import('@/views/Customer/Pet.vue'), meta: { title: '宠物管理' } },
        { path: 'customer/member-card', name: 'MemberCardTemplate', component: () => import('@/views/Customer/MemberCardTemplate.vue'), meta: { title: '会员卡模板' } },
        { path: 'customer/member-card/add', name: 'MemberCardTemplateAdd', component: () => import('@/views/Customer/MemberCardTemplateForm.vue'), meta: { title: '新增会员卡模板' } },
        { path: 'customer/member-card/edit/:id', name: 'MemberCardTemplateEdit', component: () => import('@/views/Customer/MemberCardTemplateForm.vue'), meta: { title: '编辑会员卡模板' } },
        { path: 'customer/member-card-template', redirect: '/customer/member-card' },
        { path: 'customer/member-card-template/add', redirect: '/customer/member-card/add' },
        { path: 'customer/member-card-template/edit/:id', redirect: '/customer/member-card/edit/:id' },
        { path: 'customer/time-card', name: 'TimeCardTemplate', component: () => import('@/views/Customer/TimeCardTemplate.vue'), meta: { title: '次卡模板' } },
        { path: 'customer/time-card/add', name: 'TimeCardTemplateAdd', component: () => import('@/views/Customer/TimeCardTemplateForm.vue'), meta: { title: '新增次卡模板' } },
        { path: 'customer/time-card/edit/:id', name: 'TimeCardTemplateEdit', component: () => import('@/views/Customer/TimeCardTemplateForm.vue'), meta: { title: '编辑次卡模板' } },
        { path: 'customer/point', name: 'Point', component: () => import('@/views/Customer/Point.vue'), meta: { title: '积分管理' } },
        { path: 'customer/marketing', name: 'MemberMarketing', component: () => import('@/views/Customer/MemberMarketing.vue'), meta: { title: '会员营销' } },
        // 商品服务
        { path: 'goods/commodity', name: 'Commodity', component: () => import('@/views/Goods/Commodity.vue'), meta: { title: '商品管理' } },
        { path: 'goods/brand', name: 'Brand', component: () => import('@/views/Goods/Brand.vue'), meta: { title: '品牌管理' } },
        { path: 'goods/supplier', name: 'Supplier', component: () => import('@/views/Goods/Supplier.vue'), meta: { title: '供应商管理' } },
        { path: 'goods/service', name: 'Service', component: () => import('@/views/Goods/Service.vue'), meta: { title: '服务管理' } },
        { path: 'goods/living', name: 'Living', component: () => import('@/views/Goods/Living.vue'), meta: { title: '活体管理' } },
        // 库存管理
        { path: 'stock/list', name: 'StockList', component: () => import('@/views/Stock/StockList.vue'), meta: { title: '商品库存' } },
        { path: 'stock/out', name: 'StockOut', component: () => import('@/views/Stock/StockOut.vue'), meta: { title: '出库管理' } },
        { path: 'stock/in', name: 'StockIn', component: () => import('@/views/Stock/StockIn.vue'), meta: { title: '入库管理' } },
        { path: 'stock/transfer', name: 'Transfer', component: () => import('@/views/Stock/Transfer.vue'), meta: { title: '调拨管理' } },
        { path: 'stock/living-transfer', name: 'LivingTransfer', component: () => import('@/views/Stock/LivingTransfer.vue'), meta: { title: '活体调拨' } },
        { path: 'stock/inventory-check', name: 'InventoryCheck', component: () => import('@/views/Stock/InventoryCheck.vue'), meta: { title: '盘点管理' } },
        { path: 'stock/batch', name: 'Batch', component: () => import('@/views/Stock/Batch.vue'), meta: { title: '批次管理' } },
        // 营销中心
        { path: 'marketing/tool', name: 'MarketingTool', component: () => import('@/views/Marketing/MarketingTool.vue'), meta: { title: '营销工具' } },
        { path: 'marketing/manage', name: 'MarketingManage', component: () => import('@/views/Marketing/MarketingManage.vue'), meta: { title: '营销管理' } },
        // 数据统计
        { path: 'statistics/business', name: 'BusinessReport', component: () => import('@/views/Statistics/BusinessReport.vue'), meta: { title: '营业报表' } },
        { path: 'statistics/sales', name: 'SalesReport', component: () => import('@/views/Statistics/SalesReport.vue'), meta: { title: '销售报表' } },
        { path: 'statistics/user', name: 'UserReport', component: () => import('@/views/Statistics/UserReport.vue'), meta: { title: '用户报表' } },
        { path: 'statistics/staff', name: 'StaffReport', component: () => import('@/views/Statistics/StaffReport.vue'), meta: { title: '店员报表' } },
        { path: 'statistics/chain', name: 'ChainReport', component: () => import('@/views/Statistics/ChainReport.vue'), meta: { title: '连锁报表' } },
        // 微信商城
        { path: 'wechat/my-account', name: 'MyAccount', component: () => import('@/views/WechatMall/MyAccount.vue'), meta: { title: '我的账户' } },
        { path: 'wechat/mall-goods', name: 'MallGoods', component: () => import('@/views/WechatMall/MallGoods.vue'), meta: { title: '商城商品' } },
        { path: 'wechat/online-order', name: 'OnlineOrder', component: () => import('@/views/WechatMall/OnlineOrder.vue'), meta: { title: '线上订单' } },
        { path: 'wechat/distributor', name: 'Distributor', component: () => import('@/views/WechatMall/Distributor.vue'), meta: { title: '分销员' } },
        { path: 'wechat/drop-shipping', name: 'DropShipping', component: () => import('@/views/WechatMall/DropShipping.vue'), meta: { title: '一件代发' } },
        { path: 'wechat/shop-decoration', name: 'ShopDecoration', component: () => import('@/views/WechatMall/ShopDecoration.vue'), meta: { title: '店铺装修' } },
        { path: 'wechat/mall-config', name: 'MallConfig', component: () => import('@/views/WechatMall/MallConfig.vue'), meta: { title: '商城配置' } },
        { path: 'wechat/official-account', name: 'OfficialAccount', component: () => import('@/views/WechatMall/OfficialAccount.vue'), meta: { title: '公众号' } },
        // 新零售
        { path: 'new-retail/meituan', name: 'Meituan', component: () => import('@/views/NewRetail/Meituan.vue'), meta: { title: '美团外卖' } },
        { path: 'new-retail/eleme', name: 'Eleme', component: () => import('@/views/NewRetail/Eleme.vue'), meta: { title: '饿了么' } },
        // 基础配置
        { path: 'setting/chain-library', name: 'ChainLibrary', component: () => import('@/views/Setting/ChainLibrary.vue'), meta: { title: '连锁资料库' } },
        { path: 'setting/shop', name: 'ShopManage', component: () => import('@/views/Setting/ShopManage.vue'), meta: { title: '店铺管理' } },
        { path: 'setting/staff', name: 'Staff', component: () => import('@/views/Setting/Staff.vue'), meta: { title: '店员管理' } },
        { path: 'setting/system', name: 'SystemSetting', component: () => import('@/views/Setting/SystemSetting.vue'), meta: { title: '系统设置' } },
        { path: 'setting/print', name: 'PrintSetting', component: () => import('@/views/Setting/PrintSetting.vue'), meta: { title: '打印设置' } },
        { path: 'setting/message-push', name: 'MessagePush', component: () => import('@/views/Setting/MessagePush.vue'), meta: { title: '消息推送' } },
        { path: 'setting/recycle-bin', name: 'RecycleBin', component: () => import('@/views/Setting/RecycleBin.vue'), meta: { title: '回收站' } },
      ]
    }
  ]
})

// 标记是否正在验证 token
let isVerifying = false

router.beforeEach(async (to, from, next) => {
  // 公开页面（登录页）
  if (to.meta.public) {
    if (store.getters.isLoggedIn && to.path === '/login') {
      return next('/')
    }
    return next()
  }
  
  // 检查是否有 token
  const token = localStorage.getItem('petboss_token')
  if (!token) {
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }
  
  // 如果已经有用户信息，直接放行（避免每次路由跳转都请求 /auth/me）
  if (store.getters.userName) {
    return next()
  }
  
  // 验证 token 有效性（只在首次加载或刷新时）
  if (!isVerifying) {
    isVerifying = true
    try {
      await store.dispatch('getMe')
      isVerifying = false
      next()
    } catch (error) {
      isVerifying = false
      // token 无效，清除并跳转登录
      localStorage.removeItem('petboss_token')
      localStorage.removeItem('petboss_user')
      store.commit('SET_TOKEN', '')
      store.commit('SET_USER', null)
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
  } else {
    // 正在验证中，等待
    next()
  }
})

export default router
